export default __webpack_public_path__ + "images/94b50364aa5cabdebc4f43858382dec9-arrowLeft.svg";